import React from 'react';

import { FormattedMessage } from 'react-intl';

import { PATHS } from 'constants/pathsB2c';
import { ProductModeEnum } from 'pages/b2c/Offers/models/product.model';

import { StyledContainer, StyledMessage, LinksContainer } from './ExpiredOfferMessage.style';
import { OfferLink } from '../../Message.style';

const productModeToTranslationId = {
  [ProductModeEnum.SUBSCRIPTION]: 'subscription',
  [ProductModeEnum.PAYMENT]: 'payment',
};

interface Props {
  productMode: ProductModeEnum.PAYMENT | ProductModeEnum.SUBSCRIPTION;
  productName?: string;
}

const ExpiredOfferMessage: React.FC<Props> = ({ productMode, productName }) => {
  const productModeTranslationId = productModeToTranslationId[productMode];
  return (
    <StyledContainer>
      <StyledMessage>
        <FormattedMessage id={`expired-messages.${productModeTranslationId}.message`} />
      </StyledMessage>
      <LinksContainer>
        <OfferLink
          to={PATHS.BAM_ONLINE_OFFERS}
          translationId={`expired-messages.${productModeTranslationId}.resubscribe`}
          {...(productName && { translationValues: { productName } })}
          light
        />
        <OfferLink to={PATHS.BAM_ONLINE_OFFERS} translationId='expired-messages.see-offers' />
      </LinksContainer>
    </StyledContainer>
  );
};

export default ExpiredOfferMessage;
